import AccountPreference from "../entities/AccountPreference";
import Address from "../entities/Address";
import GlobalConst from "../constants/GlobalConst";
// import { GlobalConst } from "../constants";

class Account {
    accountId = 0
    accountType = 0
    firstName = ""
    lastName = ""
    loginName = ""
    password = ""
    newPassword = ""
    email = ""
    confirmNewPassword = ""
    creationDate = 0
    modificationDate = 0
    status = 0
    availableCash = 0
    availableTFCash = 0
    availableTFMXN = 0
    availableEuro = 0
    availableMXN = 0
    availableNetBetPts = 0
    availableBalance = 0
    creationTransact = 0
    modificationTransac = 0
    pseudonym = ""
    followersCount = 0
    followingCount = 0
    phoneNumberConfirmed = false
    birthDate = null
    ranking = 0
    userClass = 0
    externalLoginProvider = ""
    idStatus = ""
    preferences =null
    address = null
    isVIP12 = false
    isReferred = false
    isReferredInLast7Days = false
    dateReferred = null
    lastReferredDate = null

    constructor(data) {
        Object.assign(this, data);
        this.preferences = new AccountPreference(data.preferences);
        this.address = new Address(data.address);
    }

    getFullName() {
        return `${this.firstName} ${this.lastName}`;
    }

    getAvailableTotal() {
        return this.availableCash + this.availableTFCash;
    }

    get culture() {
        return this.preferences.culture;
    }

    get cultureLg() {
        return this.preferences.culture.split('-')[0];
    }

    get isIdVerified() {
        return this.idStatus === "Verified";
    }

    get availableUSDBalance() {
        return this.availableCash + this.availableTFCash;
    }

    get availableEuroBalance() {
        return this.availableEuro + this.availableTFCash + this.availableNetBetPts;
    }

    get availableMXNBalance() {
        return this.availableMXN + this.availableTFMXN;
    }


    static fromJs(json) {
        if (!json) return null;
        return new Account({
            ...json,
            preferences: new AccountPreference(json.preferences),
            address: new Address(json.address)
        });
    }

    toJs() {
        const acc = { ...this };
        acc.address = this.address.toJSON();
        acc.preferences = this.preferences.toJSON();
        return acc;
    }
}

export default Account;